import React from 'react';
import './Chapters.scss';

function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">AI Innovators: Building the Future of Edge Computing</p>
        <p className="chapter__paragraph">
          Both Shaw and Chesterfield credit the Lenovo AI Innovators program with helping them
          expand their offerings worldwide.
        </p>
        <p className="chapter__paragraph">
          The program shepherds AI-focused independent software vendors (ISVs) through three program
          levels: Explore, Deploy, and Scale to help advance new AI technologies. The program gives
          ISVs access to Lenovo AI expertise and AI-ready infrastructure, helping them serve more
          customers, and helping Lenovo align its hardware engineering with software performance.
          Program participants say Lenovo expertise and infrastructure can make a major difference
          in helping them deliver the best solutions to new markets.
        </p>
        <p className="chapter__paragraph">
          According to AI Innovators program lead, Nicholas Borsotto, Explore partners have exciting
          technology in hand that still hasn’t reached a large customer base. The program gives
          those innovators access to Lenovo infrastructure experts as mentors to create reference
          architectures and proofs of concept that have the potential to scale to larger deployments
          and reach broader markets.
        </p>
        <p className="chapter__paragraph">
          The Deploy program level helps AI Innovators with well-developed technology to scale up.
          “We provide access to our AI labs in Raleigh, Stuttgart, Beijing, and Taipei,” Borsotto
          says. The goal is to find the most efficient ways for these partners to reach the next
          level. “We spend a lot of effort in the first mile—all the pre-testing, documentation—and
          the last mile, including deployment and supply chain.”
        </p>
      </section>
    </>
  );
}

export default Chapter6;
